<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <scroller class="scroller-menu" :maxWidth="1150" :offset="20" ref="scroller">
      <button-menu
        v-if="editor.logo"
        label="logo"
        :class="{'button-menu-selected': editor.logo ? isSelected(editor.logo.uid) : false}"
        @click.native.prevent="selectLogo($event)"
        iconClass="sprite-layer-logo"
      />
      <span class="separator" v-if="editor.logo"/>
      <div ref="layersGroup" class="flex horizontal layers">
        <button-layer
          class="mr-5"
          :class="{'button-menu-selected': isSelected(layer.uid)}"
          v-for="layer in layers"
          :key="layer.uid"
          :data-uid="layer.uid"
          :layer= layer
          @selectLayer= "selectByUid"
          @lockLayer="onLock"
          style="cursor: grab;"
          :lockable = lockable
        />    
      </div>
    </scroller>
  </div>
</template>
<script>
import ButtonLayer from '@/components/buttons/ButtonLayer'
import ButtonMenu from '@/components/buttons/ButtonMenu'
import menu from './menu-default'
import Sortable from 'sortablejs'
import { defined } from 'junctions-fp'
import Scroller from '@/components/scroller/Scroller'
import {mapGetters} from 'vuex'
export default {
  name: 'CalquesMenu',
  mixins: [menu],
  components: {
    ButtonLayer,
    ButtonMenu,
    Scroller
  },
  beforeCreate() {},
  created() {
    this.editor.on('addItem',this.addItem)
    this.editor.on('removeItem',this.removeItem)
    this.editor.on('selectedObject', this.onEditorSelectItem)
    this.editor.on('unselected', this.onEditorUnSelectItem)
    this.editor.on('loadedTemplate', this.onLoadTemplate)
    this.onLoadTemplate()
  },
  beforeMount() {},
  mounted() {
    this.sortable = Sortable.create(this.$refs.layersGroup, {
      onEnd: evt => {
        this.$nextTick(() => this.onUpdate(evt))
      }
    })
    this.selectedLayerUID = this.editor.getCurrentSelectedObjects().map(x => x.uid)
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    this.editor.off('addItem', this.addItem)
    this.editor.off('removeItem', this.removeItem)
    this.editor.off('selectedObject',  this.onEditorSelectItem)
    this.editor.off('unselected', this.onEditorUnSelectItem)
    this.editor.off('loadedTemplate', this.onLoadTemplate)

  },
  destroyed() {},
  data() {
    return {
      sortable: null,
      layers: [],
      selectedLayerUID: [],
      uid: 0
    }
  },
  props: {},
  computed: {

    ...mapGetters(['currentTemplate','getLimitations']),
    isSelected() {
      return uid => {
        return this.selectedLayerUID.includes(uid)
      }
    },
    lockable(){
      if(this.currentTemplate){
        if(!this.currentTemplate.public){
          return true
        }
        return this.currentTemplate.public && this.getLimitations.templatePublicCreator
      }
      return true
    }
  },
  methods: {
    addItem(item) {
      if (!item.isLogo) {
        this.layers = [...this.layers, item]
      }
    },

    selectLogo(evt) {
      this.editor.selectLogo()
      this.selectedLayerUID = this.editor.logo ? [this.editor.logo.uid] : []
    },

    removeItem(items) {
      this.layers = this.layers.filter(o => items.every(i => i.uid !== o.uid))
    },

    selectByUid(layer) {
      this.editor.selectByUID(layer.uid)
      this.selectedLayerUID = [layer.uid]
    },

    onEditorSelectItem(item) {
      //group
      if (item.type === 'activeSelection') {
        this.selectedLayerUID = item._objects.map(x => x.uid)
        return
      }
      this.selectedLayerUID = [item.uid]
    },

    onEditorUnSelectItem(items) {
      if (defined(items)) {
        const uids = items.map(x => x.uid)
        this.selectedLayerUID = this.selectedLayerUID.filter(x => !uids.includes(x))
      }
    },

    makeSelection(uids) {
      const allElements = document.querySelectorAll('[data-uid]')
      const removeClass = x => x.classList.remove('selected-layer')
      const addClass = x => (uids.includes(x.dataset.uid) ? x.classList.add('selected-layer') : '')
      allElements.forEach(removeClass)
      allElements.forEach(addClass)
    },
    onUpdate(evt) {
      this.editor.swapLayers(evt.item.dataset.uid, evt.newIndex)
      this.templateModified()
    },
    removeLayer(value) {
      this.$emit('removeLayer', value)
    },
    editLayer(value) {
      this.sortable.option('disabled', false)
    },
    getIconType(layer) {
      switch (layer.type.toLowerCase()) {
        case 'image':
          return 'sprite-images'
        case 'textbox':
          return 'sprite-text'
        default:
          return 'sprite-shape'
      }
    },
    getLabel(layer) {
      switch (layer.type) {
        case 'image':
          return 'image'
        case 'textbox':
          return layer.text
        default:
          return layer.subtype ? layer.subtype : layer.type
      }
    },
    onLock(layer){
      this.editor.lockLayer(layer.uid)
    },
    onLoadTemplate(){
       this.layers = this.editor._getCustomObjects().filter(o => o.isLogo === false)
    }
   
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/CalquesMenu.vue